<template>
  <span>
    <slot>
      <span v-show="!deleting">
        <button class="m-button danger" @click="toggleDelete">Usuń</button>
      </span>
    </slot>
    <slot name="deleting">
      <span v-show="deleting">
        <button class="m-button danger" @click="deleteClicked">Usuń</button>
        <button class="m-button second" @click="toggleDelete">Anuluj</button>
      </span>
    </slot>
  </span>
</template>

<script>
export default {
  name: 'DeleteButton',
  data() {
    return {
      deleting: false,
    }
  },
  methods: {
    toggleDelete() {
      this.deleting = !this.deleting
    },
    deleteClicked() {
      this.$emit('confirm')
    },
  },
}
</script>
